// this file added (completely changed) for individual by Bearer Web Developer (the old of this component completely changed such as it is added)
import React from "react";
import { Dialog } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useAppState } from "../../states/app-state";
import { StepForDeleteAccountEnum } from "../../states/deleteAccountState";
import RequestDeleteAccount from "./request";
import ConfirmDeleteAccount from "./confirm";
import DisabledClickLoading from "../../components/DisabledClickLoading";
// useStyles removed by Bearer Web Developer

const DeleteAccountPopup: React.FC = observer(() => {
    const appState = useAppState();
    const { deleteAccount } = appState;
    const { open, step, loading } = deleteAccount;
    const handleClose = () => {
        if (step === StepForDeleteAccountEnum.Request) deleteAccount.setOpen(false);
        else if (StepForDeleteAccountEnum.Confirm) return;
    }
    // modified by Bearer Web Developer start
    return (
        <Dialog open={open} onClose={handleClose} PaperProps={{ style: { borderRadius: "10px" } }}>
            {
                deleteAccount.step === StepForDeleteAccountEnum.Request ?
                    <RequestDeleteAccount /> : <ConfirmDeleteAccount />
            }
            {loading && <DisabledClickLoading />}
        </Dialog>
    );
    // modified by Bearer Web Developer end
})
export default DeleteAccountPopup;